module.exports = __webpack_public_path__ + "img/img_30.9c5d52e9.png";